import {
	fadeIn,
	fadeOut
} from '../util/Animation';
import View from './View';

export default class Index extends View {
	constructor(main) {
		super(main.g2d);
		this.main = main;
		this.url = 'displays/开发/首页.json';
		this.key = 'index';
		this.active = false;
		this.pageMap = main.pageMap;
		this.currentSubject = 'parkOverview';
		this.sceneMode = 'realScene';
	}
	/**
	 * 加载完场景处理
	 */
	onPostDeserialize() {
		const dm = this.dm;
		// 专题菜单
		this.subjectMenus = dm.getDataByTag('subjectMenus');

		// 园区总览初始化
		this.main.parkOverview.init();

		this.startScheduleTask();
		this.initSubject();
	}
	
	/**
	 * 有需要交互重写此方法
	 */
	handleInteractive(e) {
		const {
			kind,
			data
		} = e;
		const {
			main,
			dm,
			view,
			pageMap,
			subjectMenus
		} = this;

		// 园区总览管理页面
		const parkOverview = main.parkOverview;
		// 园区规划管理页面
		const parkPlanning = main.parkPlanning;
		// 园区建设管理页面
		const parkConstruction = main.parkConstruction;
		// 园区招商管理页面
		const parkInvestment = main.parkInvestment;
		// 园区运营管理页面
		const parkOperation = main.parkOperation;
		// 园区楼宇管理页面
		const parkBuilding = main.parkBuilding;

		if(kind === 'clickData') {
			if(!pageMap.initStatus) return;
			
			const pNode = data.getParent();
			const tag = data.getTag();

			if(pNode) {
				const pTga = pNode.getTag(); 
				// 安防系统楼层的交互
				if(pTga === 'SSF_L_1') {
					parkBuilding.openSecuritySystemFloor(parseInt(data.getDisplayName()));
					pNode.eachChild(node => {
                        node.a('isActive', node === data);
                    });
				}
			}
			
			// 专题切换
			if(pNode && pNode === subjectMenus) {
				this.switchSubject(tag);
			}
			else if(tag) {
				if(['roamScene', 'rain', 'snow', 'digitalTwin', 'trafficIntersection', 'trafficVideo', 'landPlanning', 'pipePlanning', 'bimBuilding', 'projectDistribution', 'buildingRent', 'ad', 'parking', 'organization', 'population', 'revenue', 'enterprise', 'elevatorSystem', 'lightSystem', 'fireFightingSystem', 'securitySystem', 'airConditioningSystem'].indexOf(tag) > -1) {
					data.a('active', !data.a('active'));
					data.s('state', data.a('active') ? '选中' : '默认');
				}
				switch(tag) {
					// 回到首页
					case 'home' :
						pageMap.setHomeView();
						break;
					// 园区总览 - 场景下雨
					case 'rain':
						data.a('active') ? parkOverview.openSceneRain() : parkOverview.closeSceneRain();
						break;
					// 园区总览 - 场景下雪
					case 'snow':
						data.a('active') ? parkOverview.openSceneSnow() : parkOverview.closeSceneSnow();
						break;
					// 园区总览 - 漫游场景
					case 'roamScene':
						data.a('active') ? parkOverview.startRoamPark() : parkOverview.stopRoamPark();
						break;
					// 园区总览 - 交通路口监控
					case 'trafficIntersection':
						data.a('active') ? parkOverview.openIntersectionMonitoring() : parkOverview.closeIntersectionMonitoring();
						break;
					// 园区总览 - 路口视频监控
					case 'trafficVideo':
						data.a('active') ? parkOverview.openVideoMonitoring() : parkOverview.closeVideoMonitoring();
						break;
					// 园区规划 - 用地规划
					case 'landPlanning':
						data.a('active') ? parkPlanning.openLandPlanning() : parkPlanning.closeLandPlanning();
						break;
					// 园区规划 - 管网规划
					case 'pipePlanning':
						data.a('active') ? parkPlanning.openPipePlanning() : parkPlanning.closePipePlanning();
						break;
					// 园区建设-BIM 建筑
					case 'bimBuilding':
						data.a('active') ? parkConstruction.openBIMLayer() : parkConstruction.closeBIMLayer();
						break;
					// 园区建设-项目情况
					case 'projectDistribution':
						data.a('active') ? parkConstruction.openProjectLayer() : parkConstruction.closeProjectLayer();
						break;
					// 园区招商-楼宇租赁
					case 'buildingRent':
						data.a('active') ? parkInvestment.addRentLayer() : parkInvestment.removeRentLayer();
						break;
					// 园区招商-广告位
					case 'ad':
						data.a('active') ? parkInvestment.addAdLayer() : parkInvestment.removeAdLayer();
						break;
					// 园区招商-停车场
					case 'parking':
						data.a('active') ? parkInvestment.addParkingLayer() : parkInvestment.removeParkingLayer();
						break;
					// 园区招商-服务机构
					case 'organization':
						data.a('active') ? parkInvestment.addOrganizationLayer() : parkInvestment.removeOrganizationLayer();
						break;
					// 园区运营-人口统计
					case 'population': 
						data.a('active') ? parkOperation.openPopulationLayer() : parkOperation.closePopulationLayer();
						break;	
					// 园区运营-营业额
					case 'revenue':
						data.a('active') ? parkOperation.openRevenueLayer() : parkOperation.closeRevenueLayer();
						break;		
					// 园区运营-重点企业
					case 'enterprise':
						data.a('active') ? parkOperation.openEnterpriseLayer() : parkOperation.closeEnterpriseLayer();
						break;
					// 园区楼宇-电梯系统
					case 'elevatorSystem':
						if(!parkBuilding.runSwitchSubsystem) {
							data.a('active') ? parkBuilding.switchSubsystem('elevatorSystem') : parkBuilding.switchSubsystem(null);
						}
						break;
					// 园区楼宇-照明系统
					case 'lightSystem':
						if(!parkBuilding.runSwitchSubsystem) {
							data.a('active') ? parkBuilding.switchSubsystem('lightSystem') : parkBuilding.switchSubsystem(null);
						}
						break;
					// 园区楼宇-消防系统
					case 'fireFightingSystem':
						if(!parkBuilding.runSwitchSubsystem) {
							data.a('active') ? parkBuilding.switchSubsystem('fireFightingSystem') : parkBuilding.switchSubsystem(null);
						}
						break;
					// 园区楼宇-安防系统
					case 'securitySystem':
						if(!parkBuilding.runSwitchSubsystem) {
							data.a('active') ? parkBuilding.switchSubsystem('securitySystem') : parkBuilding.switchSubsystem(null);
						}
						break;
					// 园区楼宇-空调系统
					case 'airConditioningSystem':
						if(!parkBuilding.runSwitchSubsystem) {
							data.a('active') ? parkBuilding.switchSubsystem('airConditioningSystem') : parkBuilding.switchSubsystem(null);
						}
						break;
					
					// 弹窗关闭
					case 'closeIframeDialog' :
						data.getParent().getParent().s('2d.visible', false);
						break;	
					default:
						break;
				}
				if(tag === 'closeFloorPanel') {
					const maskPanel = this.dm.getDataByTag('maskPanel');
					data.getParent().s('2d.visible', false);
					maskPanel.s('2d.visible', false);
					const sceneNode = data.getParent().getChildAt(3);
					sceneNode.a('sceneURL', '');
				}
				
				else if(tag === 'innerLightButton' || tag === 'outLightButton') {
					pNode.eachChild(node => {
						node.s('state', node === data ? 'state2' : 'state1');
					});
					const innerLightingAnim = dm.getDataByTag('innerLightingAnim');
					if(tag === 'innerLightButton') {
						pageMap.map.flyTo({
							heading: 74.64279297829377,
							height: 168.62875850566493,
							pitch: -10.305607523225369,
							position: [118.03798887804325, 24.6147876175951],
							roll: 0.002487691058987273,
							animation: {
								duration: 1500
							}
						});
						innerLightingAnim.a({
							lightTotal: 12,
							lightOpenNumber: 8,
							lightCloseNumber: 4
						});
					}
					else {
						pageMap.map.flyTo({
							hheading: 73.54475171562098,
							height: 1065.4502873765948,
							pitch: -43.37810208332954,
							position: [118.03029012134047, 24.613798998361087],
							roll: 0.0033507730168746974,
							animation: {
								duration: 1500
							}
						});
						innerLightingAnim.a({
							lightTotal: 45,
							lightOpenNumber: 43,
							lightCloseNumber: 2
						});
					}
				}
			}
		}
		else if(kind === 'onEnter') {
			const pNode = data.getParent();
			const pTag = pNode ? pNode.getTag() : null;
			if(pTag && (pNode === subjectMenus || pTag.indexOf('subjectButton.') > -1 || pTag === 'switchSceneModel')) {
				view.getView().style.cursor = 'pointer';
			}
		}
		else if(kind === 'onLeave') {
			const pNode = data.getParent();
			const pTag = pNode ? pNode.getTag() : null;
			if(pTag && (pNode === subjectMenus|| pTag.indexOf('subjectButton.') > -1 || pTag === 'switchSceneModel')) {
				view.getView().style.cursor = 'default';
			}
		}
	}

	/**
	 * 监听视图组件属性变化
	 */
	handlePropertyChange(e) {

	}
	
    /**
     * 开启图纸上的调度动画
     */
	 startScheduleTask() {
        const dm = this.dm;
        const subjectMenus = dm.getDataByTag('subjectMenus');
		const projectQuantityStatistic = dm.getDataByTag('projectQuantityStatistic');
		const resourceUse = dm.getDataByTag('resourceUse');
		const enterpriseType = dm.getDataByTag('parkOperationEnterpriseType');
		const accessApproachPanel = dm.getDataByTag('accessApproach');

		// 安防
		const securitySystemEN = dm.getDataByTag('securitySystemEquipmentNumber');
		const securitySystemMonitor = dm.getDataByTag('securitySystemMonitor');

		let step = 0.005,
			step2 = 0.01,
			step3 = 0.01,
			step4 = 0.02;

		const circleRotationParentNode = [subjectMenus, projectQuantityStatistic, resourceUse, enterpriseType, accessApproachPanel, securitySystemMonitor, securitySystemEN];
		const circleRotationNode = ['parkOperationFacilityPanel', 'lightingControlAnim', 'innerLightingAnim', 'flowMonitoring', 'BS_L_3_staff_inout', 'BS_R_2_rts'];

        if(!this.displayTask) {
            this.displayTask = {
                interval: 20,
                action: data => {
					const tag = data.getTag();
					const parentNode = data.getParent();
                    if(parentNode) {
						const pTag = parentNode.getTag();
						if(circleRotationParentNode.indexOf(parentNode) > -1 || circleRotationNode.indexOf(tag) > -1) {
							let angle = data.a('circleRotation') || 0;
							let angle2 = data.a('outCircleRotation') || 0;
							data.a('circleRotation', angle + Math.PI / 180);
							data.a('outCircleRotation', angle2 - Math.PI / 180);
						}
						if(parentNode === projectQuantityStatistic){
							const circleScale = data.a('circleScale') || 1;
							const circleOpacity = data.a('circleOpacity') || 1;
							step = circleScale >= 1 ? -0.005 : circleScale <= 0.8 ? 0.005 : step;
							data.a('circleScale', circleScale + step);
							data.a('circleOpacity', circleOpacity + step);
						}
						if(['regionBuildingDetail', 'parkOperationFacilityPanel', 'lightingControlAnim'].indexOf(tag) > -1) {
							const bgOpacity = data.a('bgOpacity') || 0.33;
							step2 = bgOpacity >= 0.8 ? -0.01 : bgOpacity <= 0.1 ? 0.01 : step2;
							data.a('bgOpacity', bgOpacity + step2);
						}
						else if(parentNode === resourceUse) {
							const circleOpacity = data.a('circleOpacity') || 1;
							step3 = circleOpacity >= 1 ? -0.01 : circleOpacity <= 0.1 ? 0.01 : step3;
							data.a('circleOpacity', circleOpacity + step3);
						}
                    }
					if(tag) {
						if(tag === 'investmentScanePanel') {
							data.a({
								circleRotation: data.a('circleRotation') - Math.PI / 180,
								circleRotation2: data.a('circleRotation2') + Math.PI / 180,
								scanRotation: data.a('scanRotation') - Math.PI / 90,
							});
						}
						if(tag.indexOf('regionLeaseArea') > -1) {
							data.a('ht.translateX', data.a('ht.translateX') + 0.1);
						}
						if(tag === 'BS_buildingIndex') {
							data.a({
								circle1: data.a('circle1') + Math.PI / 180,
								circle2: data.a('circle2') + Math.PI / 180,
								circle3: data.a('circle3') + Math.PI / 180,
								circle4: data.a('circle4') + Math.PI / 180,
							});
						}
						if(tag === 'realTimePersonnelPanel') {
							const animNode = data.getChildAt(1);
							animNode.a({
								innerCircleRotation: animNode.a('innerCircleRotation') + Math.PI / 180,
								outCircleRotation: animNode.a('outCircleRotation') + Math.PI / 180,
								outCircleScaleX: animNode.a('outCircleScaleX') + step4,
								outCircleScaleY: animNode.a('outCircleScaleY') + step4,
							});
							step4 = animNode.a('outCircleScaleY') >= 1.2 ? -0.02 : animNode.a('outCircleScaleY') <= 1 ? 0.02 : step4;
						}
					}
                }
            };
            this.dm.addScheduleTask(this.displayTask);
        }
    }

    /**
     * 停止图纸的调度动画
     */
    stopScheduleTask() {
        if(this.displayTask) {
            this.dm.removeScheduleTask(this.displayTask);
            this.displayTask = null;
        }
    }

	/**
	 * 专题切换
	 */
	switchSubject(name) {
		const {
			dm,
			main,
			currentSubject
		} = this;

		const pageMap = main.pageMap;

		if(currentSubject !== name) {
			// 园区楼宇单独处理
			if(name === 'parkBuilding') {
				pageMap.switchDigitalTwin();
				this.sceneMode = 'digitalTwin';
			}
			else {
				if(this.sceneMode !== 'realScene') {
					pageMap.switchRealScene();
					this.sceneMode = 'realScene';
				}
			}

			const preSubjectPanel = dm.getDataByTag(`${currentSubject}Subject`);
			const preSubjectButton = dm.getDataByTag(currentSubject);
			const currentSubjectPanel = dm.getDataByTag(`${name}Subject`);
			const currentSubjectButton = dm.getDataByTag(name);
			
			this.resetSubject();

			if(!preSubjectPanel.a('anim')) {
				preSubjectPanel.a('anim', true);
				preSubjectButton.a('active', false);
				currentSubjectButton.a('active', true);
				
				// 左侧
				fadeOut(preSubjectPanel.getChildAt(0), {
					callback: () => {
						fadeIn(currentSubjectPanel.getChildAt(0));
					}
				});
				
				// 右侧
				fadeOut(preSubjectPanel.getChildAt(1), {
					left: false,
					callback: () => {
						fadeIn(currentSubjectPanel.getChildAt(1), {
							left: false,
							callback: () => {
								preSubjectPanel.a('anim', false);
								this.currentSubject = name;
								if(this.main[name] && this.main[name].init) {
									this.main[name].init();
								}
							}
						});
					}
				});
			}
		}
	}

	/**
	 * 重置专题
	 */
	resetSubject() {
		const {
			main,
			dm,
			pageMap
		} = this;

		const {
			parkOverview,
			parkPlanning,
			parkConstruction,
			parkInvestment,
			parkOperation,
			parkBuilding
		} = main;

		// 重置三维场景的视角
		pageMap.setHomeView();

		// 【园区总览】相关移除
		parkOverview.clear();

		// 【园区规划】相关移除
		parkPlanning.clear();

		// 【园区建设】相关移除
		parkConstruction.clear();

		// 【园区招商】相关移除
		parkInvestment.clear();

		// 【园区运营】相关移除
		parkOperation.clear();

		// 【园区楼宇】相关移除
		parkBuilding.clear();

		// 重置所有专题按钮
		['parkOverview', 'parkPlanning' , 'parkConstruction', 'parkInvestment', 'parkOperation', 'parkBuilding'].forEach(name => {
			resetButtonStatus(dm.getDataByTag(`subjectButton.${name}Subject`));
		});
	}
	
    initSubject() {
        const dm = this.dm;
        let subjects = [
            "parkOverviewSubject",
            "parkPlanningSubject",
            "parkConstructionSubject",
            "parkInvestmentSubject",
            "parkOperationSubject",
            "parkBuildingSubject"
        ];

        subjects.forEach(tag => {
            dm.getDataByTag(tag).eachChild(child => {
                child.s('2d.visible', tag === 'parkOverviewSubject');
            });
        });
    }

}

/**
 * 重置按钮未未选中状态
 * @param {*} nodes 
 */
function resetButtonStatus(nodes) {
	nodes && nodes.eachChild(node => {
		node.s('state', '默认');
		node.a('active', false);
	});
}

